(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["paste-finder"] && !Shopify.designMode) return;
  try {
    

(function () {

  const ORDER = [
    'soft',
    'softplus',
    'pro',
    'proplus',
    'medium',
    'hard'
  ];


  const POINTS = {

    room: {

      cool: {
        soft: 2,
        softplus: 1
      },

      moderate: {
        pro: 2,
        softplus: 1
      },

      warm: {
        proplus: 2,
        pro: 1,
        medium: 1
      },

      hot: {
        medium: 2,
        hard: 2
      }

    },


    humidity: {

      low: {
        soft: 1,
        pro: 1
      },

      seasonal: {
        pro: 1,
        proplus: 1
      },

      high: {
        medium: 2,
        hard: 1
      }

    },


    experience: {

      under1: {
        medium: 3
      },

      '1to3': {
        pro: 2,
        proplus: 1
      },

      '3plus': {
        soft: 1,
        softplus: 1,
        pro: 1
      }

    },


    pace: {

      fast: {
        soft: 1,
        pro: 1
      },

      moderate: {},

      slow: {
        proplus: 1,
        medium: 1,
        hard: 1
      }

    },


    services: {

      brazilian: {
        proplus: 1,
        medium: 1,
        pro: 1
      },

      large: {
        soft: 2,
        softplus: 2,
        pro: 2
      },

      underarm: {
        proplus: 2,
        medium: 1,
        pro: 1
      },

      facial: {
        softplus: 2,
        pro: 1
      },

      mixed: {
        pro: 2
      }

    },


    challenge: {

      sticky: {
        proplus: 2,
        medium: 2,
        hard: 1
      },

      firm: {
        soft: 2,
        softplus: 1,
        pro: 1
      },

      inconsistent: {
        pro: 2,
        proplus: 1
      },

      none: {
        pro: 1
      }

    },


    hands: {

      warm: {
        proplus: 2,
        medium: 1,
        hard: 1
      },

      neutral: {
        pro: 1
      },

      cool: {
        soft: 2,
        softplus: 1
      }

    },


    mixing: {

      yes: {
        hard: 1
      },

      maybe: {},

      single: {
        pro: 1,
        medium: 1
      }

    }

  };



  function stpqIdentify(properties) {

    try {

      window.klaviyo =
        window.klaviyo || [];


      if (
        typeof window.klaviyo.identify ===
        'function'
      ) {

        return window.klaviyo.identify(
          properties
        );

      }


      if (
        typeof window.klaviyo.push ===
        'function'
      ) {

        window.klaviyo.push([
          'identify',
          properties
        ]);

      }

    }

    catch (error) {

      console.warn(
        'Paste Finder identify error',
        error
      );

    }

  }



  function stpqTrack(
    eventName,
    properties
  ) {

    try {

      window.klaviyo =
        window.klaviyo || [];


      if (
        typeof window.klaviyo.track ===
        'function'
      ) {

        return window.klaviyo.track(
          eventName,
          properties || {}
        );

      }


      if (
        typeof window.klaviyo.push ===
        'function'
      ) {

        window.klaviyo.push([
          'track',
          eventName,
          properties || {}
        ]);

      }

    }

    catch (error) {

      console.warn(
        'Paste Finder track error',
        error
      );

    }

  }



  function initializePasteFinder(root) {

    if (
      !root ||
      root.dataset.stpqInitialized ===
      'true'
    ) {
      return;
    }


    root.dataset.stpqInitialized =
      'true';



    const canWholesalePurchase =
      root.dataset.canWholesalePurchase ===
      'true';


    const professionalApplicationUrl =
      root.dataset.professionalApplicationUrl ||
      '/pages/professional-account-application';


    const loginUrl =
      root.dataset.loginUrl ||
      '/account/login';


    const cover =
      root.querySelector(
        '[data-cover]'
      );


    const main =
      root.querySelector(
        '[data-main]'
      );


    const quiz =
      root.querySelector(
        '[data-quiz]'
      );


    const lead =
      root.querySelector(
        '[data-lead]'
      );


    const results =
      root.querySelector(
        '[data-results]'
      );


    const form =
      root.querySelector(
        '[data-form]'
      );


    const leadForm =
      root.querySelector(
        '[data-lead-form]'
      );


    const nextButton =
      root.querySelector(
        '[data-next]'
      );


    const backButton =
      root.querySelector(
        '[data-back]'
      );


    const error =
      root.querySelector(
        '[data-error]'
      );


    const leadError =
      root.querySelector(
        '[data-lead-error]'
      );


    const steps =
      Array.from(
        root.querySelectorAll(
          '[data-step]'
        )
      );


    const products =
      {};


    root
      .querySelectorAll(
        '[data-products] [data-key]'
      )
      .forEach(function (element) {

        products[
          element.dataset.key
        ] = {
          ...element.dataset
        };

      });



    let currentStep =
      0;


    let finalAnswers =
      null;


    let finalRanking =
      null;



    function selected(name) {

      return form.querySelector(
        'input[name="' +
        name +
        '"]:checked'
      );

    }



    function selectedLabel(name) {

      const input =
        selected(name);


      return input
        ? input.dataset.label || ''
        : '';

    }



    function answerValues() {

      const answers =
        {};


      Object
        .keys(POINTS)
        .forEach(function (name) {

          const input =
            selected(name);


          answers[name] =
            input
              ? input.value
              : null;

        });


      return answers;

    }



    function answerLabels() {

      return {

        room:
          selectedLabel('room'),

        humidity:
          selectedLabel('humidity'),

        experience:
          selectedLabel('experience'),

        pace:
          selectedLabel('pace'),

        services:
          selectedLabel('services'),

        challenge:
          selectedLabel('challenge'),

        hands:
          selectedLabel('hands'),

        mixing:
          selectedLabel('mixing')

      };

    }



    function showStep(index) {

      currentStep =
        index;


      steps.forEach(
        function (step, i) {

          step.hidden =
            i !== index;

        }
      );


      const number =
        index + 1;


      const percent =
        Math.round(
          number /
          steps.length *
          100
        );


      root
        .querySelector(
          '[data-progress-label]'
        )
        .textContent =
          'Question ' +
          number +
          ' of ' +
          steps.length;


      root
        .querySelector(
          '[data-progress-percent]'
        )
        .textContent =
          percent + '%';


      root
        .querySelector(
          '[data-progress-bar]'
        )
        .style.width =
          percent + '%';


      root
        .querySelector(
          '[role="progressbar"]'
        )
        .setAttribute(
          'aria-valuenow',
          number
        );


      backButton.hidden =
        index === 0;


      nextButton.textContent =
        index === steps.length - 1
          ? 'Find My Match'
          : 'Next';


      error.hidden =
        true;

    }



    function rankAnswers(data) {

      const scores =
        {};


      ORDER.forEach(
        function (key) {

          scores[key] = 0;

        }
      );


      Object
        .entries(data)
        .forEach(
          function (entry) {

            const question =
              entry[0];


            const answer =
              entry[1];


            const awards =
              (
                POINTS[question] &&
                POINTS[question][answer]
              )
              || {};


            Object
              .entries(awards)
              .forEach(
                function (award) {

                  scores[
                    award[0]
                  ] +=
                    award[1];

                }
              );

          }
        );



      /* EDUCATOR BOOST */

      if (
        data.services ===
        'brazilian'
      ) {

        if (
          data.room === 'hot' ||
          data.humidity === 'high'
        ) {

          scores.hard += 2;

          scores.medium += 2;

          scores.proplus += 2;

        }

        else if (
          data.room === 'cool'
        ) {

          scores.medium += 2;

          scores.pro += 2;

          scores.proplus += 2;

        }

      }



      return ORDER

        .map(
          function (
            key,
            softness
          ) {

            return {
              key: key,
              score: scores[key],
              softness: softness
            };

          }
        )

        .sort(
          function (a,b) {

            return (
              b.score -
              a.score ||
              a.softness -
              b.softness
            );

          }
        );

    }



    function resultExplanation(
      data,
      title
    ) {

      const reasons =
        [];


      if (
        data.room === 'hot' ||
        data.humidity === 'high'
      ) {

        reasons.push(
          'your warmer or more humid working environment'
        );

      }

      else if (
        data.room === 'cool'
      ) {

        reasons.push(
          'your cooler treatment room'
        );

      }


      if (
        data.hands === 'warm'
      ) {

        reasons.push(
          'your warm hands'
        );

      }

      else if (
        data.hands === 'cool'
      ) {

        reasons.push(
          'your cool hands'
        );

      }


      if (
        data.experience ===
        'under1'
      ) {

        reasons.push(
          'your current experience level'
        );

      }


      if (
        data.challenge ===
        'sticky'
      ) {

        reasons.push(
          'your need for more stability when paste gets soft or sticky'
        );

      }

      else if (
        data.challenge ===
        'firm'
      ) {

        reasons.push(
          'your preference for a paste that glides more easily'
        );

      }


      if (
        data.services ===
        'brazilian'
      ) {

        reasons.push(
          'your focus on Brazilian and bikini services'
        );

      }


      const selectedReasons =
        reasons.slice(0,3);


      if (
        selectedReasons.length
      ) {

        let joined =
          selectedReasons.join(', ');


        joined =
          joined.replace(
            /, ([^,]*)$/,
            ' and $1'
          );


        return (
          title +
          ' matched with ' +
          joined +
          '.'
        );

      }


      return (
        title +
        ' is the closest match for the way you work.'
      );

    }



    function productCard(
      item,
      data,
      secondary
    ) {

      const product =
        products[item.key] || {};


      const exists =
        Boolean(
          product.variantId &&
          product.url
        );


      const available =
        product.available ===
        'true';


      const image =
        product.image

        ? (
          '<div class="stpq__image">' +
            '<img ' +
              'src="' +
              product.image +
              '" ' +
              'alt="' +
              (
                product.productTitle ||
                product.title ||
                ''
              ) +
              '" ' +
              'loading="lazy">' +
          '</div>'
        )

        : (
          '<div class="stpq__image"></div>'
        );



      const why =
        secondary

        ? 'A strong alternate when you want to adjust slightly softer or firmer.'

        : resultExplanation(
            data,
            product.title ||
            item.key
          );



      let actions =
        '';


      if (
        canWholesalePurchase
      ) {

        const addLabel =
          !exists
          ? 'Product unavailable'
          : (
              available
              ? (
                  'Add ' +
                  product.title +
                  ' — ' +
                  product.price
                )
              : 'Sold out'
            );


        actions +=
          '<button ' +
            'type="button" ' +
            'class="stpq__button" ' +
            'data-add="' +
            (
              product.variantId ||
              ''
            ) +
            '" ' +
            'data-recommendation-key="' +
            item.key +
            '" ' +
            (
              (!exists || !available)
                ? 'disabled'
                : ''
            ) +
          '>' +
            addLabel +
          '</button>';


        if (
          product.url
        ) {

          actions +=
            '<a ' +
              'class="stpq__button stpq__button--light" ' +
              'href="' +
              product.url +
              '" ' +
              'data-view-product="' +
              item.key +
              '">' +
              'View Product' +
            '</a>';

        }


        actions +=
          '<p ' +
            'class="stpq__status" ' +
            'data-cart-status ' +
            'aria-live="polite">' +
          '</p>';

      }

      else {

        actions +=
          '<a ' +
            'class="stpq__button" ' +
            'href="' +
            professionalApplicationUrl +
            '">' +
            'Create a Professional Account' +
          '</a>';


        actions +=
          '<a ' +
            'class="stpq__button stpq__button--light" ' +
            'href="' +
            loginUrl +
            '">' +
            'Sign In' +
          '</a>';


        actions +=
          '<div class="stpq__gate">' +
            '<strong>' +
              'Professional Purchasing' +
            '</strong>' +
            'Sign in with an approved wholesale account or apply for a professional account to purchase this paste.' +
          '</div>';

      }



      return (
        '<article class="stpq__product' +
          (
            secondary
            ? ' stpq__product--secondary'
            : ''
          ) +
        '">' +

          image +

          '<div>' +

            '<h3>' +
              (
                product.title ||
                item.key
              ) +
            '</h3>' +

            '<p class="stpq__why">' +
              why +
            '</p>' +

            (
              product.price
              ? (
                  '<p class="stpq__price">' +
                    product.price +
                  '</p>'
                )
              : ''
            ) +

            '<div class="stpq__actions">' +
              actions +
            '</div>' +

          '</div>' +

        '</article>'
      );

    }



    function openLeadCapture() {

      finalAnswers =
        answerValues();


      finalRanking =
        rankAnswers(
          finalAnswers
        );


      quiz.hidden =
        true;


      lead.hidden =
        false;


      leadError.hidden =
        true;


      setTimeout(
        function () {

          const firstField =
            leadForm.querySelector(
              '[name="first_name"]'
            );


          if (
            firstField &&
            !firstField.value
          ) {

            firstField.focus();

          }

          else {

            const emailField =
              leadForm.querySelector(
                '[name="email"]'
              );


            if (emailField) {
              emailField.focus();
            }

          }

        },
        100
      );


      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }



    function revealResults() {

      root
        .querySelector(
          '[data-primary]'
        )
        .innerHTML =
          productCard(
            finalRanking[0],
            finalAnswers,
            false
          );


      root
        .querySelector(
          '[data-secondary]'
        )
        .innerHTML =
          productCard(
            finalRanking[1],
            finalAnswers,
            true
          );


      lead.hidden =
        true;


      results.hidden =
        false;


      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }



    /* ======================================================
       START
    ======================================================= */

    root
      .querySelector(
        '[data-start]'
      )
      .addEventListener(
        'click',
        function () {

          cover.hidden =
            true;


          main.hidden =
            false;


          showStep(0);


          stpqTrack(
            'Paste Quiz Started',
            {

              Quiz:
                'Sweet & True Paste Finder',

              Quiz_Version:
                '2',

              Quiz_Page:
                window.location.pathname

            }
          );


          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      );



    /* ======================================================
       QUESTION NAV
    ======================================================= */

    nextButton.addEventListener(
      'click',
      function () {

        const choice =
          steps[currentStep]
            .querySelector(
              'input:checked'
            );


        if (
          !choice
        ) {

          error.hidden =
            false;

          return;

        }


        if (
          currentStep <
          steps.length - 1
        ) {

          showStep(
            currentStep + 1
          );

        }

        else {

          openLeadCapture();

        }

      }
    );



    backButton.addEventListener(
      'click',
      function () {

        showStep(
          Math.max(
            0,
            currentStep - 1
          )
        );

      }
    );



    steps.forEach(
      function (step) {

        step.addEventListener(
          'change',
          function () {

            error.hidden =
              true;

          }
        );

      }
    );



    /* ======================================================
       LEAD SUBMIT
    ======================================================= */

    leadForm.addEventListener(
      'submit',
      async function (event) {

        event.preventDefault();


        leadError.hidden =
          true;



        const firstName =
          leadForm
            .querySelector(
              '[name="first_name"]'
            )
            .value
            .trim();


        const lastName =
          leadForm
            .querySelector(
              '[name="last_name"]'
            )
            .value
            .trim();


        const email =
          leadForm
            .querySelector(
              '[name="email"]'
            )
            .value
            .trim();


        const marketingIntent =
          leadForm
            .querySelector(
              '[name="marketing_opt_in"]'
            )
            .checked;



        if (
          !firstName ||
          !lastName ||
          !email
        ) {

          leadError.textContent =
            'Please enter your first name, last name and email to reveal your result.';


          leadError.hidden =
            false;


          return;

        }



        const validEmail =
          /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            .test(email);


        if (
          !validEmail
        ) {

          leadError.textContent =
            'Please enter a valid email address.';


          leadError.hidden =
            false;


          return;

        }



        const revealButton =
          root.querySelector(
            '[data-reveal]'
          );


        const originalButton =
          revealButton.innerHTML;


        revealButton.disabled =
          true;


        revealButton.textContent =
          'FINDING YOUR MATCH…';



        const primary =
          finalRanking[0];


        const secondary =
          finalRanking[1];


        const primaryProduct =
          products[primary.key] || {};


        const secondaryProduct =
          products[secondary.key] || {};


        const labels =
          answerLabels();


        const completedAt =
          new Date().toISOString();



        const profileProperties = {

          email:
            email,

          first_name:
            firstName,

          last_name:
            lastName,

          'Paste Quiz Result':
            (
              primaryProduct.title ||
              primary.key
            ),

          'Paste Quiz Result Key':
            primary.key,

          'Paste Quiz Secondary':
            (
              secondaryProduct.title ||
              secondary.key
            ),

          'Paste Quiz Completed':
            true,

          'Paste Quiz Last Completed':
            completedAt,

          'Paste Quiz Marketing Intent':
            marketingIntent

        };



        const eventProperties = {

          Recommended_Paste:
            (
              primaryProduct.title ||
              primary.key
            ),

          Recommended_Paste_Key:
            primary.key,

          Recommended_Paste_URL:
            primaryProduct.url || '',

          Recommended_Paste_Variant_ID:
            primaryProduct.variantId || '',

          Recommended_Paste_Score:
            primary.score,

          Also_Consider:
            (
              secondaryProduct.title ||
              secondary.key
            ),

          Also_Consider_Key:
            secondary.key,

          Also_Consider_URL:
            secondaryProduct.url || '',

          Also_Consider_Score:
            secondary.score,

          Room_Temperature:
            labels.room,

          Humidity:
            labels.humidity,

          Experience:
            labels.experience,

          Service_Pace:
            labels.pace,

          Services:
            labels.services,

          Paste_Challenge:
            labels.challenge,

          Hand_Temperature:
            labels.hands,

          Mixing_Preference:
            labels.mixing,

          Marketing_Opt_In_Intent:
            marketingIntent,

          Quiz:
            'Sweet & True Paste Finder',

          Quiz_Version:
            '2',

          Quiz_Page:
            window.location.pathname,

          Completed_At:
            completedAt

        };



        try {

          const identifyResult =
            stpqIdentify(
              profileProperties
            );


          if (
            identifyResult &&
            typeof identifyResult.then ===
            'function'
          ) {

            await identifyResult;

          }



          const trackingResult =
            stpqTrack(
              'Paste Quiz Completed',
              eventProperties
            );


          if (
            trackingResult &&
            typeof trackingResult.then ===
            'function'
          ) {

            await trackingResult;

          }

        }

        catch (trackingError) {

          console.warn(
            'Paste Finder Klaviyo tracking issue',
            trackingError
          );

        }



        revealButton.innerHTML =
          originalButton;


        revealButton.disabled =
          false;


        revealResults();

      }
    );



    /* ======================================================
       PRODUCT VIEW TRACKING
    ======================================================= */

    results.addEventListener(
      'click',
      function (event) {

        const productLink =
          event.target.closest(
            '[data-view-product]'
          );


        if (
          !productLink
        ) {
          return;
        }


        const key =
          productLink.dataset.viewProduct;


        const product =
          products[key] || {};


        const isPrimary =
          finalRanking &&
          finalRanking[0] &&
          finalRanking[0].key === key;


        stpqTrack(
          'Paste Quiz Recommendation Viewed',
          {

            Product:
              product.title || key,

            Product_Key:
              key,

            Product_URL:
              product.url || '',

            Recommendation_Type:
              (
                isPrimary
                ? 'Primary'
                : 'Secondary'
              ),

            Primary_Recommendation:
              (
                finalRanking
                ? (
                    products[
                      finalRanking[0].key
                    ].title
                  )
                : ''
              )

          }
        );

      }
    );



    /* ======================================================
       ADD TO CART
    ======================================================= */

    results.addEventListener(
      'click',
      async function (event) {

        const button =
          event.target.closest(
            '[data-add]'
          );


        if (
          !button ||
          button.disabled
        ) {
          return;
        }



        const status =
          button
            .parentElement
            .querySelector(
              '[data-cart-status]'
            );


        const original =
          button.textContent;


        const key =
          button.dataset
            .recommendationKey;


        const product =
          products[key] || {};


        const isPrimary =
          finalRanking &&
          finalRanking[0] &&
          finalRanking[0].key === key;


        button.disabled =
          true;


        button.textContent =
          'Adding…';


        if (status) {
          status.textContent = '';
        }



        try {

          const rootPath =
            (
              window.Shopify &&
              window.Shopify.routes &&
              window.Shopify.routes.root
            )
            || '/';


          const response =
            await fetch(
              rootPath +
              'cart/add.js',
              {

                method:
                  'POST',

                headers: {

                  'Content-Type':
                    'application/json',

                  'Accept':
                    'application/json'

                },

                body:
                  JSON.stringify({

                    items: [

                      {

                        id:
                          Number(
                            button.dataset.add
                          ),

                        quantity:
                          1

                      }

                    ]

                  })

              }
            );


          if (
            !response.ok
          ) {

            throw new Error(
              'Could not add this paste.'
            );

          }



          button.textContent =
            'Added to Cart ✓';


          if (status) {

            status.textContent =
              'Your paste is in the cart.';

          }



          stpqTrack(
            'Paste Quiz Recommendation Added to Cart',
            {

              Product:
                product.title || key,

              Product_Key:
                key,

              Product_URL:
                product.url || '',

              Product_Variant_ID:
                product.variantId || '',

              Product_Price:
                product.price || '',

              Recommendation_Type:
                (
                  isPrimary
                  ? 'Primary'
                  : 'Secondary'
                ),

              Primary_Recommendation:
                (
                  finalRanking
                  ? (
                      products[
                        finalRanking[0].key
                      ].title
                    )
                  : ''
                ),

              Also_Consider:
                (
                  finalRanking
                  ? (
                      products[
                        finalRanking[1].key
                      ].title
                    )
                  : ''
                )

            }
          );



          document.dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true
              }
            )
          );


          document.dispatchEvent(
            new CustomEvent(
              'cart:updated',
              {
                bubbles: true
              }
            )
          );

        }

        catch (error) {

          button.disabled =
            false;


          button.textContent =
            original;


          if (status) {

            status.textContent =
              (
                error.message ||
                'Please try again.'
              );

          }

        }

      }
    );



    /* ======================================================
       RETAKE
    ======================================================= */

    root
      .querySelector(
        '[data-retake]'
      )
      .addEventListener(
        'click',
        function () {

          form.reset();

          leadForm.reset();


          finalAnswers =
            null;


          finalRanking =
            null;


          results.hidden =
            true;


          lead.hidden =
            true;


          quiz.hidden =
            false;


          showStep(0);


          stpqTrack(
            'Paste Quiz Retaken',
            {

              Quiz:
                'Sweet & True Paste Finder',

              Quiz_Version:
                '2'

            }
          );


          root.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }
      );



    showStep(0);

  }



  function initializeAllPasteFinders() {

    document
      .querySelectorAll(
        '[data-stpq-root]'
      )
      .forEach(
        initializePasteFinder
      );

  }



  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAllPasteFinders
    );

  }

  else {

    initializeAllPasteFinders();

  }



  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const sectionRoot =
        event.target.querySelector
        ? event.target.querySelector(
            '[data-stpq-root]'
          )
        : null;


      if (sectionRoot) {

        initializePasteFinder(
          sectionRoot
        );

      }

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-ask-zestie"] && !Shopify.designMode) return;
  try {
    
(() => {
  const redactSensitive = value => String(value || '')
    .replace(/\b(?:sk-(?:proj-)?[A-Za-z0-9_-]{12,}|shp(?:at|ss|ca)_[A-Za-z0-9]{12,}|Bearer\s+[A-Za-z0-9._-]{16,})/gi,'[••••]')
    .replace(/\b\d{3}-\d{2}-\d{4}\b/g,'[••••]')
    .replace(/(\b(?:my\s+)?password\s*(?:is|:|=)\s*)\S+/gi,'$1[••••]')
    .replace(/(?<!\d)(?:\d[ -]?){12,18}\d(?!\d)/g,match=>{
      const digits=match.replace(/\D/g,'');
      if(digits.length<13||digits.length>19)return match;
      const sum=[...digits].reverse().reduce((total,digit,index)=>{const n=Number(digit)*(index%2?2:1);return total+(n>9?n-9:n);},0);
      return sum%10===0?'[••••]':match;
    });
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const one = s => root.querySelector(s);
    const dialog = one('dialog'), home = one('[data-z-home]'), messages = one('[data-z-messages]'), support = one('[data-z-support]'), scroller = one('[data-z-scroll]'), search = one('[data-z-search]'), form = one('.zst-support-form');
    const strings = Object.fromEntries(Object.entries(JSON.parse(one('[data-z-strings]').textContent)).map(([k,v])=>[k,v.replaceAll('&amp;','&').replaceAll('&#39;',"'").replaceAll('&quot;','\"')]));
    const t = (key, args = {}) => Object.entries(args).reduce((s,[k,v]) => s.replaceAll('{'+k+'}',String(v)), strings[key] || key);
    const setThinking = active => { root.dataset.thinking=String(active); one('[data-z-subtitle]').textContent=t(active?'ai_thinking':'subtitle'); };
    const entries = Array.from(one('[data-z-knowledge]').content.querySelectorAll('article')).map((a,id)=>({id,question:a.querySelector('h3').textContent.trim(),answer:a.querySelector('p').textContent.trim(),category:a.dataset.category,keywords:a.dataset.keywords,links:Array.from(a.querySelectorAll('a')).map(l=>({label:l.textContent.trim(),url:l.getAttribute('href')}))}));
    let transcript = [], request = null, account = null, stage = '', pending = null, activeChoices = null, generation = 0, submitting = false;
    const aiEnabled = root.dataset.aiEnabled === 'true';
    const aiPath = /^\/apps\/[a-z0-9-]+$/.test(root.dataset.aiPath || '') ? root.dataset.aiPath : '/apps/ask-zestie';
    let aiSession = '', aiBusy = false, aiAbort = null, aiDraft = null;
    const field = name => form.elements.namedItem('contact['+name+']');
    const normalize = text => text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9 ]/g,' ').replace(/\s+/g,' ').trim();
    const stop = new Set('i me my the a an is are it can do does how what when where why to of for in with and or you your have get this that want need please im its'.split(' '));
    const accountUrl = one('[data-z-account]').href;
    const safeLink = url => {
      try { const u = new URL(url,location.origin), a = new URL(accountUrl); return (u.protocol==='https:' && [location.hostname,a.hostname,'www.sweetandtruesugaring.com','sweetandtruesugaring.com','sugaringcertificate.com','www.sugaringcertificate.com'].includes(u.hostname)) || (u.protocol==='mailto:' && u.pathname==='care@sweetandtruesugaring.com'); } catch { return false; }
    };
    const scrollEnd = () => { scroller.scrollTop = scroller.scrollHeight; };
    const showMessages = () => { home.hidden=true; support.hidden=true; messages.hidden=false; search.hidden=false; };
    const saveTranscript = () => { const text=transcript.slice(-60).map(m=>m.role+': '+redactSensitive(m.text)).join('\n\n').slice(-18000); one('[data-z-transcript]').value=text; one('[data-z-context-preview]').textContent=text; one('[data-z-summary]').hidden=!text; };
    const open = () => { if(!dialog.open) dialog.showModal(); one('[data-z-close]').focus(); };
    const close = () => { dialog.close(); one('[data-z-open]').focus(); };
    const addLink = (box,label,url,cls='') => { if(!safeLink(url)) return; const a=document.createElement('a'); a.textContent=label; a.href=url; a.className=cls; if(url===accountUrl || (url.startsWith('https:') && new URL(url).hostname!==location.hostname)){a.target='_blank';a.rel='noopener noreferrer';} box.append(a); };
    const message = (text,role='answer',links=[],byline='') => {
      text=redactSensitive(text);
      showMessages(); const box=document.createElement('div'); box.className='zst-message '+role;
      if(byline){const small=document.createElement('span');small.className='zst-byline';small.textContent=byline;box.append(small);}
      const p=document.createElement('p');p.textContent=text;box.append(p);links.forEach(l=>addLink(box,l.label,l.url));messages.append(box);
      transcript.push({role:role==='user'?'Customer':'Zestie',text});saveTranscript();scrollEnd();return box;
    };
    const retire = () => { if(activeChoices) activeChoices.querySelectorAll('button').forEach(b=>{b.disabled=true;}); activeChoices=null; pending=null; };
    const options = (box,list) => {
      retire(); const wrap=document.createElement('div');wrap.className='zst-choices';
      list.forEach(([label,fn])=>{const b=document.createElement('button');b.type='button';b.textContent=label;b.addEventListener('click',()=>{retire();message(label,'user');fn();});wrap.append(b);});box.append(wrap);activeChoices=wrap;
      pending={type:'choice',list};scrollEnd();
    };
    const ask = (key,choices=[],handler=null,args={}) => { retire();const box=message(t(key,args));if(choices.length)options(box,choices);if(handler)pending={type:'text',handler,list:choices};return box; };
    const clear = () => {
      if(aiAbort)aiAbort.abort();
      if(aiSession)fetch(aiPath+'/reset',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({session:aiSession}),keepalive:true}).catch(()=>{});
      aiSession='';aiDraft=null;aiBusy=false;setThinking(false);search.querySelector('button').disabled=false;search.querySelector('input').disabled=false;
      generation++;retire();transcript=[];request=null;account=null;stage='';submitting=false;form.reset();messages.replaceChildren();home.hidden=false;messages.hidden=true;support.hidden=true;search.hidden=false;search.reset();one('[data-z-progress]').hidden=true;saveTranscript();scroller.scrollTop=0;
    };
    const cancel = () => {
      if(!request){clear();return;}
      const previous=pending;
      options(message(t('cancel_confirm')),[[t('cancel_yes'),()=>{clear();message(t('cancelled'));}],[t('cancel_no'),()=>{pending=previous;resume();}]]);
    };
    const loadAccount = async nextUrl => {
      const url=new URL(nextUrl || one('[data-z-account-endpoint]').href,location.origin);
      if(url.origin!==location.origin)throw new Error('Invalid account origin');
      url.searchParams.set('section_id','st-zestie-account');
      const response=await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'},signal:AbortSignal.timeout(12000)});
      if(!response.ok)throw new Error('Account unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const data=doc.querySelector('[data-z-account-data]');if(!data)throw new Error('Account unavailable');
      if(data.dataset.authenticated!=='true')return {authenticated:false,orders:[]};
      const text=(el,s)=>el.querySelector(s)?.textContent.trim()||'';
      return {authenticated:true,name:text(data,'[data-z-name]'),email:text(data,'[data-z-email]'),next:data.querySelector('[data-z-next]')?.getAttribute('href')||'',orders:Array.from(data.querySelectorAll('[data-z-order]')).map(o=>({name:o.dataset.name,date:o.dataset.date,created:o.dataset.created,status:o.dataset.status,url:o.dataset.url,address:Array.from(o.querySelectorAll('[data-z-address] span')).map(a=>a.textContent.trim()).filter(Boolean).join('\n'),items:Array.from(o.querySelectorAll('[data-z-item]')).map(i=>({id:i.dataset.id,name:i.dataset.name,quantity:Number(i.dataset.quantity),sku:i.dataset.sku}))})).sort((a,b)=>b.created.localeCompare(a.created))};
    };
    const checkAccount = async (older=false) => {
      stage='account';retire();const token=++generation;const waitBox=message(t('checking_account'));
      try {
        const loaded=await loadAccount(older?account?.next:null);if(token!==generation)return;
        waitBox.remove();
        if(older){if(!loaded.authenticated){account=loaded;request.order=null;return guest();}account.orders.push(...loaded.orders.filter(o=>!account.orders.some(x=>x.name===o.name)));account.next=loaded.next;return chooseOrder();}
        account=loaded;
        if(!account.authenticated)return guest();
        request.name ||= account.name;request.email ||= account.email;
        if(!account.orders.length){message(t('no_orders'));return orderNumber();}
        previewOrder(account.orders[0],true);
      } catch {
        if(token!==generation)return;waitBox.remove();
        options(message(t('account_error')),[[t('retry'),()=>checkAccount(older)],[t('manual'),orderNumber]]);
      }
    };
    const guest = () => {stage='account';options(message(t('guest_intro'),'answer',[{label:t('login'),url:accountUrl}]),[[t('check_login'),()=>checkAccount()],[t('manual'),orderNumber]]);};
    const orderText = order => [order.name,t('order_date',{date:order.date}),t('order_status',{status:order.status}),t('order_contents')+':',...order.items.map(i=>i.quantity+' × '+i.name)].join('\n');
    const previewOrder = (order,recent=false) => {
      stage='select_order';const box=message((recent?t('recent_order',{order:order.name}):order.name)+'\n\n'+orderText(order));
      options(box,[[t('yes_this_order'),()=>selectOrder(order)],[t('different_order'),chooseOrder]]);
    };
    const chooseOrder = () => {stage='choose_order';const list=account.orders.map(o=>[o.name+' · '+o.date,()=>previewOrder(o)]);if(account.next)list.push([t('older_orders'),()=>checkAccount(true)]);list.push([t('other_number'),orderNumber]);options(message(t('choose_order')),list);};
    const orderNumber = () => {stage='order_number';request.order=null;ask('order_number_prompt',[[t('no_number'),()=>{request.orderName=t('number_unknown');issue();}]],q=>{request.orderName=q.slice(0,80);issue();});};
    const selectOrder = order => {request.order=order;request.orderName=order.name;if(request.tracking){const box=message(orderText(order)+'\n\n'+t('status_help'),'answer',[{label:t('view_order'),url:order.url||accountUrl}]);options(box,[[t('help'),()=>{request.tracking=false;issue();}],[t('tracking_only'),()=>{request=null;stage='';retire();one('[data-z-progress]').hidden=true;message(t('helpful_reply'));}]]);}else issue();};
    const kinds = ['missing','damaged','wrong','not_arrived','other_order'];
    const detectKind = q => /\b(damag|broken|crack|leak)/i.test(q)?'damaged':/\b(wrong|incorrect)\b/i.test(q)?'wrong':/\b(whole order|never arrived|hasn.t arrived|not arrived|package.*missing|order.*missing$)\b/i.test(q)?'not_arrived':/\b(missing|short|left out)\b/i.test(q)?'missing':null;
    const issue = () => {stage='issue';const inferred=detectKind(request.initial);const choices=kinds.map(k=>[t(k),()=>setIssue(k)]);const box=message(t('issue_prompt'));options(box,inferred?[choices.find(x=>x[0]===t(inferred)),...choices.filter(x=>x[0]!==t(inferred))]:choices);};
    const setIssue = kind => {request.issue=kind;if(['missing','damaged','wrong'].includes(kind))item();else details();};
    const item = () => {
      stage='item';const list=(request.order?.items||[]).filter(i=>request.items.filter(x=>x.id===i.id).reduce((s,x)=>s+x.quantity,0)<i.quantity).map(i=>[i.name+' · '+i.quantity+' ordered',()=>quantity(i)]);
      if(list.length){list.push([t('manual_item'),manualItem]);options(message(t('choose_item')),list);}else manualItem();
    };
    const manualItem = () => {stage='manual_item';ask('item_name_prompt',[],q=>quantity({id:'manual-'+request.items.length,name:q.slice(0,200),quantity:null,sku:''}));};
    const quantity = selected => {
      stage='quantity';request.itemDraft=selected;
      ask('quantity_prompt',[[t('change_item'),item]],q=>{const words={one:1,two:2,three:3,four:4,five:5,six:6,seven:7,eight:8,nine:9,ten:10};const raw=q.trim().toLowerCase(),value=words[raw]??(/^\d+(?: (?:jars?|bottles?|units?|items?))?$/.test(raw)?Number(raw.split(' ')[0]):NaN);const n=value,used=request.items.filter(i=>i.id===selected.id).reduce((s,i)=>s+i.quantity,0),max=selected.quantity===null?999:selected.quantity-used;
        if(!Number.isInteger(n)||n<1||n>max){message(t('quantity_invalid',{max}));quantity(selected);return;}
        request.items.push({id:selected.id,name:selected.name,sku:selected.sku,quantity:n,issue:t(request.issue)});
        stage='more_items';options(message(t('item_added',{quantity:n,item:selected.name,issue:t(request.issue)})),[[t('add_item'),issue],[t('items_done'),details]]);
      },{item:selected.name,limit:selected.quantity===null?'':t('quantity_limit',{quantity:selected.quantity})});
    };
    const details = () => {
      stage='details';const key=request.issue==='not_arrived'?'not_arrived_detail':'detail_prompt';
      ask(key,request.initial?[[t('keep_details'),()=>{request.detail=request.initial;afterDetails();}]]:[],q=>{request.detail=q;afterDetails();});
      if(request.initial)message(request.initial,'answer',[],t('summary_initial'));
    };
    const afterDetails = () => {
      if(request.general)return contactName();
      stage='boxes';ask('boxes_prompt',[],q=>{request.boxes=q;if(request.issue==='not_arrived'||request.issue==='other_order')address();else photos();});
    };
    const photos = () => {stage='photos';options(message(t('photos_prompt')),['photos_yes','photos_later','photos_no'].map(k=>[t(k),()=>{request.photos=t(k);message(t('photo_note'));address();}]));};
    const address = () => {
      stage='address';const original=request.order?.address;
      if(original)ask('address_confirm',[[t('address_yes'),()=>{request.address=original;resolution();}],[t('address_change'),manualAddress]],null,{address:original});else manualAddress();
    };
    const manualAddress = () => {stage='manual_address';ask('address_prompt',[],q=>{if(q.length<12){message(t('empty_answer'));manualAddress();return;}request.address=q;message(t('address_note'));resolution();});};
    const resolution = () => {stage='resolution';ask('resolution_prompt',['resolution_replace','resolution_refund','resolution_help'].map(k=>[t(k),()=>{request.resolution=t(k);contactName();}]),q=>{request.resolution=q;contactName();});};
    const contactName = (manual=false) => {
      stage='name';if(request.name&&!manual)ask('name_confirm',[[t('yes_name'),()=>contactEmail()],[t('different_name'),()=>contactName(true)]],null,{name:request.name});
      else ask('name_prompt',[],q=>{request.name=q.slice(0,120);contactEmail();});
    };
    const contactEmail = (manual=false) => {
      stage='email';if(request.email&&!manual)ask('email_confirm',[[t('yes_email'),review],[t('different_email'),()=>contactEmail(true)]],null,{email:request.email});
      else ask('email_prompt',[],q=>{if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(q)||q.length>254){message(t('email_invalid'));return contactEmail(true);}request.email=q;review();});
    };
    const summary = () => {
      const pairs=[['summary_category',request.general?t('summary_general'):t('order_issue')],['summary_initial',request.initial],['summary_order',request.general?'':request.orderName],['summary_account',request.general?'':request.order?t('source_signed_in'):t('source_manual')],['summary_items',request.general?'':request.items.map(i=>i.quantity+' × '+i.name+(i.sku?' [SKU '+i.sku+']':'')+' — '+i.issue).join('\n')||t('summary_no_items')],['summary_details',request.detail],['summary_boxes',request.boxes],['summary_photos',request.photos],['summary_address',request.address],['summary_original_address',request.order?.address&&request.address!==request.order.address?request.order.address:''],['summary_resolution',request.resolution]];
      return t('summary_title')+'\n\n'+pairs.filter(([,v])=>v).map(([k,v])=>t(k)+':\n'+v).join('\n\n');
    };
    const updateEmail = () => {
      const body=redactSensitive([t('name')+': '+field('name').value,t('email')+': '+field('email').value,'',field('body').value].join('\n'));
      one('[data-z-photo-email]').href='mailto:care@sweetandtruesugaring.com?subject='+encodeURIComponent(t('email_subject',{order:field('order_number').value||t('summary_general')}))+'&body='+encodeURIComponent(body);
    };
    const review = () => {
      stage='review';retire();message(t('review_intro'));field('name').value=request.name||'';field('email').value=request.email||'';field('order_number').value=request.general?'':request.orderName||'';field('request_type').value=request.general?t('summary_general'):t('order_issue');field('body').value=summary();one('[data-z-confirm]').checked=false;saveTranscript();updateEmail();showReview();
    };
    const showReview = () => {home.hidden=true;messages.hidden=true;support.hidden=false;search.hidden=true;one('[data-z-progress]').hidden=true;scroller.scrollTop=0;support.querySelector('h3').focus();};
    const general = () => {request.general=true;stage='general';ask('general_prompt',request.initial?[[t('keep_details'),()=>{request.detail=request.initial;contactName();}]]:[],q=>{request.detail=q;contactName();});};
    const begin = (initial='',mode='auto') => {
      if(request)return resume();
      request={initial,items:[],name:'',email:'',tracking:mode==='tracking'};one('[data-z-progress]').hidden=false;
      if(mode==='order'||mode==='tracking')return checkAccount();stage='start';options(message(t('support_start')),[[t('yes_order'),()=>checkAccount()],[t('general_help'),general]]);
    };
    const resume = () => {
      if(!request)return;
      showMessages();one('[data-z-progress]').hidden=false;
      if(stage==='review'){showReview();return;}
      const render={account:()=>checkAccount(),select_order:chooseOrder,choose_order:chooseOrder,order_number:orderNumber,issue,item,manual_item:manualItem,quantity:()=>quantity(request.itemDraft),more_items:()=>options(message(t('choose_item')),[[t('add_item'),issue],[t('items_done'),details]]),details,boxes:afterDetails,photos,address,manual_address:manualAddress,resolution,name:()=>contactName(),email:()=>contactEmail(),general,start:()=>options(message(t('support_start')),[[t('yes_order'),()=>checkAccount()],[t('general_help'),general]])};
      if(render[stage])render[stage]();scrollEnd();
    };
    const faqAnswer = id => {const e=entries[id];retire();const box=message(e.answer,'answer',e.links,t('answer_label'));addLink(box,t('source'),'/pages/faq-sugaring-hair-removal','zst-source');};
    const findAnswer = q => {
      const n=normalize(q);
      const intentRules=[[/\b(shelf life|expir\w*|how long.*(?:paste|sugar).*last)\b/,8],[/\b(?:store|storage)\b.*\b(?:paste|sugar)\b|\b(?:paste|sugar)\b.*\b(?:store|storage)\b/,7],[/\b(?:ingredients?)\b.*\b(?:paste)\b|\b(?:paste)\b.*\b(?:ingredients?)\b/,9],[/\b(minimum.*order|moq)\b/,17],[/\b(weekends?|holidays?|saturday|sunday)\b.*\b(order|ship|process)|\b(order|ship|process)\w*.*\b(weekends?|holidays?|saturday|sunday)\b/,25],[/\b(order processing|processing time|how long.*process)\b/,24],[/\b(return policy|refund policy)\b/,28]];
      const intent=intentRules.find(([pattern])=>pattern.test(n));if(intent)return faqAnswer(intent[1]);
      const expanded=n.replace(/\bstuck\b/g,'sticky').replace(/\bconsistency\b/g,'paste');
      const tokens=Array.from(new Set(expanded.split(' ').filter(t=>t.length>1&&!stop.has(t))));
      const match=(w,t)=>w===t||(t.length>4&&w.startsWith(t));
      const corpora=entries.map(e=>normalize(e.question+' '+e.keywords).split(' '));
      const weight=t=>Math.log(1+entries.length/(1+corpora.filter(words=>words.some(w=>match(w,t))).length));
      const total=tokens.reduce((sum,t)=>sum+weight(t),0);
      const ranked=entries.map((e,i)=>{const title=normalize(e.question),matched=tokens.filter(t=>corpora[i].some(w=>match(w,t)));return {e,score:matched.reduce((sum,t)=>sum+weight(t)*(title.includes(t)?1.4:1),0),ratio:total?matched.reduce((sum,t)=>sum+weight(t),0)/total:0,exact:title===n};}).filter(r=>r.score>=2&&r.ratio>=.45).sort((a,b)=>Number(b.exact)-Number(a.exact)||b.score-a.score);
      if(ranked.length&&(ranked[0].exact||((ranked.length===1||ranked[0].score>=ranked[1].score*1.2)&&ranked[0].ratio>=.65)))return faqAnswer(ranked[0].e.id);
      if(ranked.length){options(message(t('results')),ranked.slice(0,4).map(r=>[r.e.question,()=>faqAnswer(r.e.id)]));return;}
      const box=message(t('no_match'),'answer',[{label:t('catalog_search'),url:'/search?type=product&q='+encodeURIComponent(q)}]);options(box,[[request?t('resume'):t('help'),()=>request?resume():begin(q)]]);
    };
    const aiReview = draft => {
      recordSupportRequest();
      request={general:true,initial:'',items:[],name:draft.name||'',email:draft.email||'',orderName:draft.order_reference||''};stage='review';retire();
      field('name').value=request.name;field('email').value=request.email;field('order_number').value=request.orderName;field('request_type').value=t('summary_general');
      field('body').value=redactSensitive(draft.summary||transcript.filter(m=>m.role==='Customer').map(m=>m.text).join('\n'));one('[data-z-confirm]').checked=false;saveTranscript();updateEmail();showReview();
    };
    const recordSupportRequest = () => {
      if(aiSession)fetch(aiPath+'/support-requested',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({session:aiSession}),keepalive:true}).catch(()=>{});
    };
    const feedbackControls = (box,turnId,sessionToken) => {
      const wrap=document.createElement('div');wrap.className='zst-feedback';
      const status=document.createElement('span');status.setAttribute('role','status');
      for(const [value,key] of [['helpful','feedback_helpful'],['not_helpful','feedback_not_helpful']]){
        const button=document.createElement('button');button.type='button';button.textContent=t(key);
        button.addEventListener('click',async()=>{
          wrap.querySelectorAll('button').forEach(b=>{b.disabled=true;});
          try{
            const response=await fetch(aiPath+'/feedback',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({session:sessionToken,turn_id:turnId,value}),signal:AbortSignal.timeout(10000)});
            if(!response.ok)throw new Error();status.textContent=t('feedback_saved');
          }catch{status.textContent=t('feedback_retry');wrap.querySelectorAll('button').forEach(b=>{b.disabled=false;});}
        });wrap.append(button);
      }
      wrap.append(status);box.append(wrap);
    };
    const directHandoff = () => {
      recordSupportRequest();
      if(aiAbort)aiAbort.abort();generation++;aiBusy=false;setThinking(false);search.querySelector('button').disabled=false;search.querySelector('input').disabled=false;
      if(request&&stage==='review')return showReview();
      if(aiDraft)return aiReview(aiDraft);
      aiReview({name:field('name').value,email:field('email').value,order_reference:field('order_number').value,summary:field('body').value||transcript.filter(m=>m.role==='Customer').map(m=>m.text).join('\n')});
    };
    const aiReceive = async (q, retryId=null) => {
      q=redactSensitive(q);
      if(aiBusy)return;retire();if(!retryId)message(q,'user');aiBusy=true;setThinking(true);
      const token=++generation,requestId=retryId||crypto.randomUUID();
      aiAbort=new AbortController();const controller=aiAbort;
      const timer=setTimeout(()=>controller.abort(),100000);
      const sendButton=search.querySelector('button');sendButton.disabled=true;search.querySelector('input').disabled=true;
      const waitBox=document.createElement('div');waitBox.className='zst-thinking';waitBox.setAttribute('role','status');
      const thought=document.createElement('span');thought.className='zst-thinking-copy';thought.textContent=t('ai_thinking');
      const dots=document.createElement('span');dots.className='zst-dots';dots.setAttribute('aria-hidden','true');
      for(let i=0;i<3;i++)dots.append(document.createElement('i'));
      thought.append(dots);waitBox.append(thought);messages.append(waitBox);scrollEnd();
      try{
        if(!aiSession){
          const response=await fetch(aiPath+'/session',{credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json'}});
          const result=await response.json();if(!response.ok||!result.session)throw new Error(result.error||'setup_required');if(token!==generation)return;aiSession=result.session;
        }
        const response=await fetch(aiPath+'/chat',{method:'POST',credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({session:aiSession,request_id:requestId,message:q,history_notice:'review-v1'})});
        const result=await response.json();if(token!==generation)return;if(!response.ok||typeof result.text!=='string')throw new Error(result.error||'service_unavailable');
        waitBox.remove();one('.zst-preview').textContent=t('ai_badge');one('.zst-source-note').textContent=t('ai_source_note');one('.zst-real-send').textContent=t('ai_support_notice');
        const answerBox=message(result.text,'answer',Array.isArray(result.links)?result.links:[],t('ai_byline'));
        if(result.history_saved&&result.turn_id)feedbackControls(answerBox,result.turn_id,aiSession);
        const updatedDraft=result.draft&&result.draft.status==='draft_not_sent';
        if(updatedDraft)aiDraft=result.draft;
        if(aiDraft)options(updatedDraft?message(t('ai_review_ready')):answerBox,[[t('ai_review'),()=>aiReview(aiDraft)]]);
      }catch(error){
        if(token!==generation)return;waitBox.remove();
        const changed=['account_changed','session_expired','conversation_limit'].includes(error.message);
        if(changed){aiSession='';aiDraft=null;transcript=[];messages.replaceChildren();request=null;account=null;stage='';form.reset();saveTranscript();}
        const box=message(t(changed?'ai_session_changed':'ai_unavailable'));
        options(box,[[t(changed?'ai_start_again':'retry'),()=>changed?clear():aiReceive(q,requestId)],[t('help'),directHandoff]]);
      }finally{
        clearTimeout(timer);waitBox.remove();if(token===generation){aiBusy=false;setThinking(false);sendButton.disabled=false;search.querySelector('input').disabled=false;search.querySelector('input').focus();}
      }
    };
    const receive = q => {
      q=redactSensitive(q);
      if(aiEnabled)return aiReceive(q);
      message(q,'user');const n=normalize(q);
      if(/\b(revenue|profit|payroll|salary|salaries|margins)\b|how many orders?.*(?:they|you).*(?:day|month|year)/i.test(q)){retire();message(t('business_boundary'));return;}
      if(/^(?:at home|at my home)[.! ]*$/i.test(q)||/\b(diy|homemade|self[- ]sugaring)\b|sugar(?:ing)?.{0,20}(?:myself|my own)/i.test(q)){retire();message(t('professional_boundary'));return;}
      if(/\b(reaction|burned|burnt|blister|bleeding|allergic|rash|infection)\b/i.test(q)){retire();options(message(t('sensitive')),[[request?t('resume'):t('help'),()=>request?resume():begin(q)]]);return;}
      if(request && /^(cancel|start over|reset)$/i.test(q))return cancel();
      if(request && /^(how|what|can|does|why|when|do you|is your)\b.+\?$/i.test(q)){retire();return findAnswer(q);}
      if(request && pending){
        const choices=pending.list||[],exact=choices.find(([label])=>normalize(label)===n);
        const yes=/^(yes|yep|yeah|correct|that s right|that s the one)$/.test(n),no=/^(no|nope|different)$/.test(n);
        let picked=exact;
        if(!picked&&pending.type==='choice'&&choices.length===2&&(yes||no))picked=choices[yes?0:1];
        if(!picked&&stage==='issue'){const kind=detectKind(q);picked=choices.find(([label])=>label===t(kind));}
        if(picked){retire();return picked[1]();}
        if(pending.type==='text'){const fn=pending.handler;retire();return fn(q);}
        if(/^(how|what|can|does|why|when)\b/i.test(q)){retire();return findAnswer(q);}
        message(t('selection_hint'));return;
      }
      if(request){if(/^(hi|hello|hey|thanks|thank you)$/.test(n)){message(t(n==='thanks'||n==='thank you'?'thanks':'greeting'));return resume();}if(/^(how|what|can|does|why|when)\b/i.test(q))return findAnswer(q);return resume();}
      if(/^(hi|hello|hey|hiya|good morning|good afternoon)( zestie)?$/.test(n)){message(t('greeting'));return;}
      if(/^(thanks|thank you|thank you so much|thanks zestie|perfect|great|awesome)$/.test(n)){message(t('thanks'));return;}
      if(/\b(joke|funny)\b/.test(n)){message(t('joke'));return;}
      if(/\b(who are you|are you real|are you ai|are you human|what can you do)\b/.test(n)){message(t('identity'));return;}
      if(/\b(track|tracking|where.*order|order status)\b/i.test(q))return begin(q,'tracking');
      if(detectKind(q)||/\b(cancel my order|change my order|order issue)\b/i.test(q))return begin(q,'order');
      if(/\b(human|customer service|talk to|speak to|contact.*team|support|representative)\b/i.test(q))return begin(q);
      findAnswer(q);
    };
    root.querySelectorAll('[data-z-topic]').forEach(b=>b.addEventListener('click',()=>{
      if(aiEnabled)return aiReceive(t(b.dataset.zTopic));
      const topic=b.dataset.zTopic;message(t(topic),'user');if(topic==='orders')return begin('', 'order');
      const links=topic==='paste'?[{label:t('quiz'),url:'/pages/sugar-paste-quiz'},{label:t('shop_paste'),url:'/collections/sugaring-paste'}]:topic==='education'?[{label:t('classes'),url:'/pages/sugaring-education'}]:[{label:t('catalog'),url:'/search?type=product'}];
      const box=message(t(topic==='paste'?'paste_intro':topic==='education'?'education_intro':'product_intro'),'answer',links);options(box,entries.filter(e=>e.category===topic).slice(0,5).map(e=>[e.question,()=>faqAnswer(e.id)]));
    }));
    search.addEventListener('submit',event=>{event.preventDefault();const input=search.querySelector('input'),q=input.value.trim();if(!q)return;input.value='';receive(q);});
    one('[data-z-open]').addEventListener('click',open);one('[data-z-close]').addEventListener('click',close);one('[data-z-help]').addEventListener('click',()=>aiEnabled?directHandoff():begin());one('[data-z-reset]').addEventListener('click',cancel);one('[data-z-back-chat]').addEventListener('click',()=>{showMessages();options(message(t('resume_hint')),[[t('resume'),showReview]]);});
    dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
    form.addEventListener('input',()=>{one('[data-z-confirm]').checked=false;updateEmail();});
    one('[data-z-confirm]').addEventListener('input',event=>{event.stopPropagation();});
    form.addEventListener('submit',event=>{if(submitting){event.preventDefault();return;}['name','email','order_number','body'].forEach(key=>{field(key).value=redactSensitive(field(key).value);});saveTranscript();submitting=true;const button=form.querySelector('[type=submit]');button.textContent=t('sending');button.setAttribute('aria-disabled','true');});
    window.addEventListener('pageshow',event=>{if(event.persisted){clear();close();}});
    if(one('[data-z-success]')||one('[data-z-errors]')){open();showReview();}
  };
  document.querySelectorAll('[data-zestie]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-zestie]').forEach(initialize));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-ft-pro-source-pdp"] && !Shopify.designMode) return;
  try {
    
function initializeFreeTrueProfessional(root) {
  if (!root || root.dataset.stReady === 'true') return;
  root.dataset.stReady = 'true';
  const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const setupRail = (rail, trackSelector, slideSelector, dotSelector, threshold) => {
    const track = rail.querySelector(trackSelector);
    const slides = [...rail.querySelectorAll(slideSelector)];
    const dots = [...rail.querySelectorAll(dotSelector)];
    const previous = rail.querySelector('[data-ft-arrow="prev"]');
    const next = rail.querySelector('[data-ft-arrow="next"]');
    if (!track || slides.length < 2) return;
    let index = 0;
    const mark = i => {
      index = Math.max(0, Math.min(i, slides.length - 1));
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === index);
        if (n === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };
    const go = i => {
      i = Math.max(0, Math.min(i, slides.length - 1));
      const left = slides[i].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({left, behavior});
      mark(i);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    previous?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); go(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) mark(slides.indexOf(entry.target));
      });
    }, {root:track, threshold});
    slides.forEach(slide => observer.observe(slide));
    rail.dataset.ftEnhanced = 'true';
    mark(0);
  };
  root.querySelectorAll('[data-ft-gal]').forEach(rail => setupRail(rail, '[data-ft-track]', '[data-ft-slide]', '[data-ft-dot]', 0.6));
  root.querySelectorAll('[data-ft-steprail]').forEach(rail => setupRail(rail, '[data-ft-steptrack]', '[data-ft-step]', '[data-ft-stepdot]', 0.9));
  root.querySelectorAll('.ft-formula').forEach(section => {
    const images = [...section.querySelectorAll('[data-ft-image]')];
    const items = [...section.querySelectorAll('details[data-ft-item]')];
    const show = item => {
      const image = images.find(image => image.dataset.ftImage === item.dataset.ftItem);
      if (!image) return;
      images.forEach(node => { node.classList.toggle('is-active', node === image); node.hidden = node !== image; });
    };
    items.forEach(item => item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach(other => { if (other !== item) other.open = false; });
      show(item);
    }));
    if (items.length) show(items.find(item => item.open) || items[0]);
  });
  root.querySelectorAll('[data-ft-steps]').forEach(section => {
    const play = section.querySelector('[data-ft-play]');
    const close = section.querySelector('[data-ft-close]');
    const player = section.querySelector('[data-ft-player]');
    if (!play || !player) return;
    play.addEventListener('click', () => {
      const embed = play.getAttribute('data-ft-embed');
      if (embed) {
        const frame = document.createElement('iframe');
        frame.className = 'ft-steps__frame'; frame.src = embed;
        frame.title = play.getAttribute('aria-label');
        frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true;
        player.append(frame);
      } else player.querySelector('video')?.play();
      player.hidden = false; play.hidden = true; if (close) close.hidden = false;
    });
    close?.addEventListener('click', () => {
      player.querySelector('iframe')?.remove(); player.querySelector('video')?.pause();
      player.hidden = true; play.hidden = false; close.hidden = true; play.focus();
    });
  });
  root.querySelector('[data-st-ft-variant]')?.addEventListener('change', event => {
    const url = new URL(location.href); url.searchParams.set('variant', event.target.value); location.assign(url);
  });
}
document.querySelectorAll('[data-st-ft-pro-source]').forEach(initializeFreeTrueProfessional);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-st-ft-pro-source]').forEach(initializeFreeTrueProfessional));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-ft-source-pdp"] && !Shopify.designMode) return;
  try {
    
function initializeFreeTrue(root) {
  if (!root || root.dataset.stReady === 'true') return;
  root.dataset.stReady = 'true';
  const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const setupRail = (rail, trackSelector, slideSelector, dotSelector, threshold) => {
    const track = rail.querySelector(trackSelector);
    const slides = [...rail.querySelectorAll(slideSelector)];
    const dots = [...rail.querySelectorAll(dotSelector)];
    const previous = rail.querySelector('[data-ft-arrow="prev"]');
    const next = rail.querySelector('[data-ft-arrow="next"]');
    if (!track || slides.length < 2) return;
    let index = 0;
    const mark = i => {
      index = Math.max(0, Math.min(i, slides.length - 1));
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === index);
        if (n === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (previous) previous.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };
    const go = i => {
      i = Math.max(0, Math.min(i, slides.length - 1));
      const left = slides[i].offsetLeft - slides[0].offsetLeft;
      track.scrollTo({left, behavior});
      mark(i);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    previous?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); go(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) mark(slides.indexOf(entry.target));
      });
    }, {root:track, threshold});
    slides.forEach(slide => observer.observe(slide));
    rail.dataset.ftEnhanced = 'true';
    mark(0);
  };
  root.querySelectorAll('[data-ft-gal]').forEach(rail => setupRail(rail, '[data-ft-track]', '[data-ft-slide]', '[data-ft-dot]', 0.6));
  root.querySelectorAll('[data-ft-steprail]').forEach(rail => setupRail(rail, '[data-ft-steptrack]', '[data-ft-step]', '[data-ft-stepdot]', 0.9));
  root.querySelectorAll('.ft-formula').forEach(section => {
    const images = [...section.querySelectorAll('[data-ft-image]')];
    const items = [...section.querySelectorAll('details[data-ft-item]')];
    const show = item => {
      const image = images.find(image => image.dataset.ftImage === item.dataset.ftItem);
      if (!image) return;
      images.forEach(node => { node.classList.toggle('is-active', node === image); node.hidden = node !== image; });
    };
    items.forEach(item => item.addEventListener('toggle', () => {
      if (!item.open) return;
      items.forEach(other => { if (other !== item) other.open = false; });
      show(item);
    }));
    if (items.length) show(items.find(item => item.open) || items[0]);
  });
  root.querySelectorAll('[data-ft-steps]').forEach(section => {
    const play = section.querySelector('[data-ft-play]');
    const close = section.querySelector('[data-ft-close]');
    const player = section.querySelector('[data-ft-player]');
    if (!play || !player) return;
    play.addEventListener('click', () => {
      const embed = play.getAttribute('data-ft-embed');
      if (embed) {
        const frame = document.createElement('iframe');
        frame.className = 'ft-steps__frame'; frame.src = embed;
        frame.title = play.getAttribute('aria-label');
        frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true;
        player.append(frame);
      } else player.querySelector('video')?.play();
      player.hidden = false; play.hidden = true; if (close) close.hidden = false;
    });
    close?.addEventListener('click', () => {
      player.querySelector('iframe')?.remove(); player.querySelector('video')?.pause();
      player.hidden = true; play.hidden = false; close.hidden = true; play.focus();
    });
  });
  root.querySelector('[data-st-ft-variant]')?.addEventListener('change', event => {
    const url = new URL(location.href); url.searchParams.set('variant', event.target.value); location.assign(url);
  });
}
document.querySelectorAll('[data-st-ft-source]').forEach(initializeFreeTrue);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-st-ft-source]').forEach(initializeFreeTrue));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-loyalty-page"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
 const trigger = event.target.closest('[data-st-open-rewards]');
 if (!trigger) return;
 const launcher = document.getElementById('nav-toggle-widget');
 const panel = document.getElementById('nav-close');
 const fallback = trigger.closest('.st-loyalty').querySelector('[data-st-rewards-fallback]');
 if (panel && panel.getClientRects().length) { fallback.hidden = true; return; }
 if (launcher && launcher.getClientRects().length) { launcher.click(); fallback.hidden = true; }
 else { fallback.hidden = false; fallback.scrollIntoView({block:'center',behavior:'smooth'}); }
});

  } catch(e) { console.error(e); }
})();
})();
